import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const token = params.get("token") || "";
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [done, setDone] = useState(false);
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState("");

    const handle = async (e) => {
        e.preventDefault(); setErr(""); setLoading(true);
        if (password !== confirm) { setErr("Fjalëkalimet nuk përputhen."); setLoading(false); return; }
        try {
            await api.post("/auth/reset-password", { token, new_password: password });
            setDone(true);
            setTimeout(() => navigate("/login"), 2500);
        } catch (e2) { setErr(formatApiError(e2.response?.data?.detail) || e2.message); }
        finally { setLoading(false); }
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-6 paper-bg">
            <div className="w-full max-w-md">
                <div className="flex flex-col items-center text-center mb-8">
                    <img src="/gg-logo.png" alt="German Gymnasium" className="w-20 h-20 object-contain mb-3" />
                    <h1 className="font-heading text-2xl font-black text-oxford">German Gymnasium</h1>
                </div>
                <div className="bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
                    <h2 className="font-heading text-2xl font-bold text-slate-900 mb-2">Vendos fjalëkalim të ri</h2>
                    {!token ? (
                        <div className="text-sm text-terracotta">Linku është i pavlefshëm. <Link to="/forgot-password" className="font-semibold underline">Kërko link të ri.</Link></div>
                    ) : done ? (
                        <div className="text-center py-6 space-y-3" data-testid="reset-success">
                            <CheckCircle2 className="w-12 h-12 text-sage mx-auto" />
                            <div className="font-heading text-xl font-bold text-slate-900">Fjalëkalimi u ndryshua!</div>
                            <div className="text-sm text-slate-600">Po ju kthejmë në faqen e hyrjes…</div>
                        </div>
                    ) : (
                        <form onSubmit={handle} className="space-y-4" data-testid="reset-form">
                            <Input type="password" placeholder="Fjalëkalimi i ri (min 6)" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} data-testid="reset-pwd-input" className="h-11 bg-white" />
                            <Input type="password" placeholder="Konfirmo fjalëkalimin" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={6} data-testid="reset-confirm-input" className="h-11 bg-white" />
                            {err && <div className="text-sm text-terracotta bg-terracotta/10 border border-terracotta/30 rounded-lg px-4 py-2" data-testid="reset-error">{err}</div>}
                            <Button type="submit" disabled={loading} className="w-full h-11 bg-oxford hover:bg-oxfordhover text-white font-semibold" data-testid="reset-submit">
                                {loading ? "Duke ndryshuar…" : "Ruaj Fjalëkalimin"}
                            </Button>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
}
